<template>
  <div class="tab">
    <tab-pane title="首页" :activeTab="activeTab" :value="1" @change="clickHandle"></tab-pane>
    <tab-pane title="产品目录" :activeTab="activeTab" :value="2" @change="clickHandle"></tab-pane>
    <tab-pane title="分类选型" :activeTab="activeTab" :value="3" @change="clickHandle" v-if="showLecto"></tab-pane>
    <tab-pane title="联系我们" :activeTab="activeTab" :value="4" @change="clickHandle"></tab-pane>
    <tab-pane title="关于我们" :activeTab="activeTab" :value="5" @change="clickHandle"></tab-pane>
  </div>
</template>
<script>
import {AuthService} from '/@/service'
import TabPane from "./tab-pane.vue";

export default {
  components: {
    TabPane,
  },
  props: {
    compId: {
      type: [Number, String],
      default: 1,
    },
  },
  computed: {
    showLecto() {
      return AuthService.getLectoByCompid(this.compId);
    }
  },
  data() {
    return {
      activeTab: 1,
    };
  },
  methods: {
    clickHandle(value) {
      this.activeTab = value;
      let urlArr = ['/company/home','/product/list','/company/lecto','/company/contact','/company/about'];
      this.$router.push(`${urlArr[value - 1]}/${this.compId}`);
    },
  },
};
</script>
<style lang="less">
.tab-pane {
  height: 30px;
  line-height: 30px;
  padding: 0 25px;
  border-radius: 30px;
  color: @text-color-base;
  text-align: center;
  margin-right: 15px;
  cursor: pointer;

  &.active {
    background-color: @main-color;
    color: #ffffff;
  }
}
</style>